import React from 'react'; // eslint-disable-line

class Template extends React.Component {
    constructor(props) {
        super(props);
        this.onClickFn = this.onClickFn.bind(this);
    }

    componentDidMount() {
        if (this.props.solo) {
            this.onClickFn();
        }
    }

    onClickFn = () => {
        if (this.props.onClick) {
            this.props.onClick(this.props.id);
        }
    }

    render() { // eslint-disable-next-line
        return (<div />);
    }
}

export default Template;
